'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Carousel = require('../../main/jsx/Carousel');

var _Carousel2 = _interopRequireDefault(_Carousel);

var _HomePageHero = require('./HomePageHero');

var _HomePageHero2 = _interopRequireDefault(_HomePageHero);

var _breakpoints = require('../../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'hero-carousel';

var HeroCarousel = function (_React$Component) {
  _inherits(HeroCarousel, _React$Component);

  function HeroCarousel(props) {
    _classCallCheck(this, HeroCarousel);

    var _this = _possibleConstructorReturn(this, (HeroCarousel.__proto__ || Object.getPrototypeOf(HeroCarousel)).call(this, props));

    _this.state = {
      isDesktop: false
    };

    _this.handleResize = _this.handleResize.bind(_this);
    _this.handleNavigationClick = _this.handleNavigationClick.bind(_this);
    return _this;
  }

  _createClass(HeroCarousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('click', this.handleNavigationClick);
      this.handleResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('click', this.handleNavigationClick);
    }

    /* Work around for checking if navigation is open/close */

  }, {
    key: 'handleNavigationClick',
    value: function handleNavigationClick(e) {
      var el = e.target;

      if (el.rel === 'menuitem') {
        this.carousel.pause();
      } else if (el.getAttribute('role') === 'button' && el.title === 'Close') {
        this.carousel.resume();
      }
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      var newWindowWidth = this.organismRef.ownerDocument.defaultView.innerWidth || this.organismRef.ownerDocument.documentElement.clientWidth || this.organismRef.ownerDocument.body.clientWidth;

      if (newWindowWidth > _breakpoints2.default.large) {
        if (!this.state.isDesktop) {
          this.setState({
            isDesktop: true
          });
        }
      } else if (this.state.isDesktop) {
        this.setState({
          isDesktop: false
        });
      }
    }
  }, {
    key: 'renderHero',
    value: function renderHero(slides, viewport) {
      var _this2 = this;

      if (slides) {
        return slides.map(function (props, idx) {
          return _react2.default.createElement(_HomePageHero2.default, _extends({}, props, {
            index: idx,
            className: ORGANISM_NAME + '__carousel__hero',
            key: ORGANISM_NAME + '-' + idx,
            clientType: viewport,
            height: _this2.props.config.height,
            theme: props.theme || _this2.props.config.theme
          }));
        });
      }
      return null;
    }
  }, {
    key: 'renderCarousel',
    value: function renderCarousel(slides, viewport) {
      var _this3 = this;

      var autoplayInterval = this.props.config.autoplayInterval;

      var options = {
        startSlide: 0,
        speed: 400,
        auto: autoplayInterval,
        className: ORGANISM_NAME,
        continuous: false
      };

      var newKey = '' + (viewport.toString() + slides.length + (this.props.config.height || 'tall'));

      return _react2.default.createElement(
        'div',
        {
          key: newKey,
          className: ORGANISM_NAME + '__wrapper'
        },
        _react2.default.createElement(
          _Carousel2.default,
          {
            ref: function ref(domPath) {
              _this3.carousel = domPath;
            },
            className: ORGANISM_NAME + '__carousel',
            trackId: this.props.config.trackId,
            options: options,
            numberCounterThreshold: this.props.config.numberCounterThreshold,
            renderNumberCounter: this.props.config.renderNumberCounter,
            content: this.props.content.carousel,
            callback: this.props.callback
          },
          this.renderHero(slides, viewport)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var slides = this.props.content.slides;

      var heroCarouselClasses = (0, _classnames2.default)(ORGANISM_NAME, this.props.className, this.props.config.theme);
      return _react2.default.createElement(
        'section',
        {
          className: heroCarouselClasses,
          'data-building-block': 'organism',
          ref: function ref(c) {
            _this4.organismRef = c;
          }
        },
        this.renderCarousel(slides, this.props.viewport)
      );
    }
  }]);

  return HeroCarousel;
}(_react2.default.Component);

/* Default content */


exports.default = HeroCarousel;
HeroCarousel.propTypes = {
  viewport: _propTypes2.default.string,
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    autoplayInterval: _propTypes2.default.number,
    trackId: _propTypes2.default.string,
    height: _propTypes2.default.string,
    theme: _propTypes2.default.string,
    numberCounterThreshold: _propTypes2.default.number,
    renderNumberCounter: _propTypes2.default.bool
  }),
  content: _propTypes2.default.shape({
    carousel: _propTypes2.default.shape({
      goToSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      goToNextSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      goToPreviousSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      })
    }),
    slides: _propTypes2.default.arrayOf(_propTypes2.default.shape(_HomePageHero2.default.propTypes)).isRequired
  }),
  className: _propTypes2.default.string,
  callback: _propTypes2.default.func
};

HeroCarousel.defaultProps = {
  viewport: 'dedicated',
  config: {
    id: '',
    autoplayInterval: 6000,
    trackId: 'HCarousel',
    height: 'tall',
    theme: 'theme-background-image-dark',
    numberCounterThreshold: 6,
    renderNumberCounter: false
  },
  content: {
    carousel: {
      goToSlide: {
        text: 'Go to slide'
      },
      goToNextSlide: {
        text: 'Go to next slide'
      },
      goToPreviousSlide: {
        text: 'Go to previous slide'
      }
    },
    slides: [_HomePageHero2.default.defaultProps, _HomePageHero2.default.defaultProps]
  },
  className: '',
  callback: function callback() {}
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/carousel/hero-carousel/jsx/HeroCarousel.js
// module id = 1073
// module chunks = 4